import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SessionKeys } from "../../utils/AppUtils";
import {
  getLeaderBoardClear,
  getLeaderBoardReq,
  saveLeaderboard,
} from "../../redux/user/actions";
import _ from "lodash";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import {
  shareImage,
  shareImageResponseClear,
} from "../../redux/events/actions";
import CONFIG from "../../utils/config";
import Loader from "../Loader/Loader";
import OfficeSelectComp from "./OfficeSelectComp";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./LeaderBoardComp.scss";
import { ButtonGroup, ToggleButton } from "react-bootstrap";
import { use } from "i18next";

const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <span
    className="shar-btn"
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
  >
    {children}
  </span>
));
const LeaderBoardComp = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const leaderBoardDataTestRes = useSelector((state) => state.user.leaderBoard);
  const saveLeaderboardRes = useSelector((state) => state.user.saveLeaderboardRes);
  const authBroker = useSelector((state) => state.auth.authBroker);
  const imageUrlRes = useSelector((state) => state.events.shareImageRes);
  const userRole = useSelector((state) => state.user.role);
  const { t } = useTranslation();
  const [leaderBoardData, setLeaderBoardData] = useState([]);
  const [lastUpdateTime, setLastUpdateTime] = useState("");
  const [clickedShareBtn, setClickedShareBtn] = useState(0);

  const [fbTagetUrl, setfbTagetUrl] = useState();
  const [linkedinTargetUrl, setlinkedinTargetUrl] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const [selectedOfficeList, setSelectedOfficeList] = useState([]);
  const [tabKey, setTabKey] = useState("last_month");
  const [parentTabKey, setParentTabKey] = useState("agents");
  const [isCheckedAnmos, setIsCheckedAnmos] = useState(false);
  const [isCheckedPublish, setIsCheckedPublish] = useState(false);
  const [isAllChecked, setIsAllChecked] = useState(true);
  const [rankSort, setRankSort] = useState("asc");

  useEffect(() => {
    getLeaderBoardData();
  }, [tabKey, parentTabKey]);

  useEffect(() => {
    // console.log('leaderBoardDataTestRes: ',leaderBoardDataTestRes);
    if (!_.isEmpty(leaderBoardDataTestRes)) {
      setIsLoading(false);
      if (leaderBoardDataTestRes?.status === "success") {
        let list = _.cloneDeep(leaderBoardDataTestRes?.payload?.payload?.list);
        let exclude_users = _.cloneDeep(leaderBoardDataTestRes?.payload?.payload?.exclude_users);
        let leaderboard_status = _.cloneDeep(leaderBoardDataTestRes?.payload?.payload?.leaderboard_status);
        setIsCheckedPublish(leaderboard_status?.publish_status === "yes" ? true : false);
        setIsCheckedAnmos(leaderboard_status?.anonymous_status === "yes" ? true : false);
        for (const item of list) {
          if (exclude_users && !_.isEmpty(exclude_users)) {
            item.isChecked = exclude_users?.includes(item.user_id) ? false : true;
          } else {
            item.isChecked = true;
          }


        }
        console.log("list: ", list);
        setLeaderBoardData(list);
        setLastUpdateTime(
          moment
            .unix(leaderBoardDataTestRes?.payload?.payload?.last_updated)
            .format("Do MMMM YYYY, h:mm A")
        );
        dispatch(getLeaderBoardClear());
      } else {
        setLeaderBoardData([]);
      }
    }
  }, [leaderBoardDataTestRes]);

  useEffect(() => {
    if (leaderBoardData.length > 0) {
      if (rankSort === "asc") {
        setLeaderBoardData(_.orderBy(leaderBoardData, ['rank'], ['asc']));
      } else {
        setLeaderBoardData(_.orderBy(leaderBoardData, ['rank'], ['desc']));
      }
    }
  }, [rankSort])

  let selectedOffice = [];
  selectedOfficeList.forEach((element) => {
    selectedOffice.push(element.office_id);
  });

  //get leader board
  const getLeaderBoardData = () => {
    setIsLoading(true);
    dispatch(
      getLeaderBoardReq({
        module: "leaderBoard",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          user_id: localStorage.getItem(SessionKeys.USER_ID),
          office_id: selectedOffice,
          tab: tabKey,
          filter_tab: parentTabKey
        },
      })
    );
  };

  useEffect(() => {
    if (clickedShareBtn > 0) {
      getBlobForAllEvents();
    }
  }, [clickedShareBtn]);

  const getBlobForAllEvents = () => {
    console.log("shareJson: ", leaderBoardData);
    let reqArr = [];
    for (let i = 0; i < leaderBoardData.length; i++) {
      const item = leaderBoardData[i];
      let tempObj = {
        name: item?.name,
        rank: item.rank,
        office: item.office,
        score: item?.score,
        profile: item.profile,
        is_me: item.is_me,
      };
      reqArr.push(tempObj);

      // if (i === 8) {
      //   break;
      // }
    }

    setIsLoading(true);
    dispatch(
      shareImage({
        module: "shareImageLeaderBoard",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          content_top: reqArr?.slice(0, 3),
          content_table:
            reqArr.length > 3 ? reqArr?.slice(3, reqArr.length) : [],
        },
      })
    );
  };

  useEffect(() => {
    if (!_.isEmpty(imageUrlRes)) {
      setIsLoading(false);
      if (imageUrlRes?.status === "success") {
        console.log("respo", imageUrlRes);
        setfbTagetUrl(imageUrlRes?.payload?.payload?.fb_target_url);
        setlinkedinTargetUrl(
          imageUrlRes?.payload?.payload?.linkedin_target_url
        );

        let pdfUrl =
          CONFIG.API_URL_BROKER_ADMIN + imageUrlRes?.payload?.payload?.pdf_url;
        let imgUrl =
          CONFIG.API_URL_BROKER_ADMIN + imageUrlRes?.payload?.payload?.data;
        let fbUrl = imageUrlRes?.payload?.payload?.fb_target_url;
        let linkedInUrl = imageUrlRes?.payload?.payload?.linkedin_target_url;
        console.log("responseShare", clickedShareBtn);

        let shareUrl =
          clickedShareBtn === 1
            ? pdfUrl
            : clickedShareBtn === 2
              ? imgUrl
              : clickedShareBtn === 3
                ? fbUrl
                : clickedShareBtn === 4
                  ? linkedInUrl
                  : "";

        if (clickedShareBtn > 0) {
          window.open(shareUrl, "_blank");
          setClickedShareBtn(0);
          dispatch(shareImageResponseClear());
        }
      }
    }
  }, [imageUrlRes, dispatch]);

  const saveLeaderboardReq = () => {
    let uncheckedList = [];
    for (const item of leaderBoardData) {
      if (!item.isChecked) {
        uncheckedList.push(item.user_id);
      }
    }
    setIsLoading(true);
    dispatch(
      saveLeaderboard({
        module: "saveLeaderboard",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          exclude_uids: uncheckedList,
          publish_status: isCheckedPublish ? "yes" : "no",
          anonymous_status: isCheckedAnmos ? "yes" : "no"
        },
      })
    );
  }


  useEffect(() => {
    if (!_.isEmpty(saveLeaderboardRes)) {
      setIsLoading(false);
      if (saveLeaderboardRes?.status === "success") {
        getLeaderBoardData();
      }
    }
  }, [saveLeaderboardRes])

  useEffect(() => {
    isAllCheckFunc();
  }, [leaderBoardData])

  const isAllCheckFunc = () => {
    let isAllCheck = true;
    for (const item of leaderBoardData) {
      if (!item.isChecked) {
        isAllCheck = false;
        break;
      }
    }
    setIsAllChecked(isAllCheck)
  }


  return (
    <>
      <Loader start={isLoading} />
      <div className="row">

        <div className="col-md-12 mb-3">
          <h1 className="requesthead d-flex gap-2 align-items-center">

            {t("leaderboard")}

          </h1>


          {<Tabs
            defaultActiveKey="agents"
            id="justify-tab-example"
            className="mb-3 maintab"
            justify
            onSelect={(k) => {
              console.log("selectKey: ", k);
              setLeaderBoardData([]);
              setParentTabKey(k);
            }}
          >
            <Tab eventKey="agents" title={t("Agents")}></Tab>
            <Tab eventKey="teams" title={t("Teams")}></Tab>
          </Tabs>}
          <div className="lb-data my_courses">
            <div className="mb-3 d-flex justify-content-between isto gap-3 flex-column">
              <h4 className="requestheadineer d-flex  align-items-center mb-3 mt-3">
                {t("Top Trained Agents")}
              </h4>
              <Tabs
                defaultActiveKey="last_month"
                id="justify-tab-example"
                justify
                onSelect={(k) => {
                  console.log("selectKey: ", k);
                  setTabKey(k);
                }}
              >
                <Tab eventKey="last_week" title={t("Last Week")}></Tab>
                <Tab eventKey="last_month" title={t("Last Month")}></Tab>
                <Tab eventKey="overall" title={t("Overall")}></Tab>
              </Tabs>
            </div>

            <div className="lw-filters filters-leaderboard-cd">
              <div className="inner-content-caoch pt-4">
                <div className="s-earch-and-filters d-flex gap-4 justify-content-between mb-5">
                  <div className="search-filter position-relative">
                    <input
                      type="search"
                      placeholder={t("Search")}
                      id="inputPassword2"
                      className="form-control"
                    />
                    {false && (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        // onClick={handleSearchClick}
                        className="cursor-pointer"
                      >
                        <path
                          d="M19.6973 18.3984L14.4629 13.1641C15.5957 11.7969 16.2207 10.0391 16.2207 8.125C16.2207 3.67188 12.5489 0 8.09571 0C3.60352 0 0.00976562 3.67188 0.00976562 8.125C0.00976562 12.6172 3.64258 16.25 8.09571 16.25C9.97071 16.25 11.7286 15.625 13.1348 14.4922L18.3692 19.7266C18.5645 19.9219 18.7989 20 19.0723 20C19.3067 20 19.541 19.9219 19.6973 19.7266C20.0879 19.375 20.0879 18.7891 19.6973 18.3984ZM1.88477 8.125C1.88477 4.6875 4.65821 1.875 8.13477 1.875C11.5723 1.875 14.3848 4.6875 14.3848 8.125C14.3848 11.6016 11.5723 14.375 8.13477 14.375C4.65821 14.375 1.88477 11.6016 1.88477 8.125Z"
                          fill="black"
                        />
                      </svg>
                    )}
                  </div>

                  <div className="filter-section">
                    <div className="filter-option-listing d-flex justify-content-end gap-3">
                      {false && <Dropdown className="filter-btn">
                        <Dropdown.Toggle
                          variant="success"
                          id="dropdown-basic"
                        >
                          {t("County")}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="10"
                            viewBox="0 0 20 10"
                            fill="none"
                          >
                            <path
                              d="M18.9587 1.78879L10.7517 9.65205C10.4939 9.86695 10.236 9.95285 10.0212 9.95285C9.7634 9.95285 9.50559 9.86695 9.29074 9.69505L1.04074 1.78879C0.611052 1.40207 0.611052 0.714569 0.99777 0.327849C1.38449 -0.101839 2.07199 -0.101839 2.45871 0.284879L10.0212 7.50363L17.5407 0.284879C17.9274 -0.101839 18.615 -0.101839 19.0017 0.327849C19.3884 0.714569 19.3884 1.40207 18.9587 1.78879Z"
                              fill="#2D2D2D"
                            />
                          </svg>
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="drop-down-menu">

                          <Dropdown.Item
                            //key={index}
                            className="dropdown-menu-item"
                            onClick={() => {
                              // setSelectedCity(skill);
                              // setActiveTab("currentMonth");
                            }}
                          >
                            Country On1
                          </Dropdown.Item>

                        </Dropdown.Menu>
                      </Dropdown>}
                      {false && <Dropdown className="filter-btn">
                        <Dropdown.Toggle
                          variant="success"
                          id="dropdown-basic"
                        >
                          {t("Role")}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="10"
                            viewBox="0 0 20 10"
                            fill="none"
                          >
                            <path
                              d="M18.9587 1.78879L10.7517 9.65205C10.4939 9.86695 10.236 9.95285 10.0212 9.95285C9.7634 9.95285 9.50559 9.86695 9.29074 9.69505L1.04074 1.78879C0.611052 1.40207 0.611052 0.714569 0.99777 0.327849C1.38449 -0.101839 2.07199 -0.101839 2.45871 0.284879L10.0212 7.50363L17.5407 0.284879C17.9274 -0.101839 18.615 -0.101839 19.0017 0.327849C19.3884 0.714569 19.3884 1.40207 18.9587 1.78879Z"
                              fill="#2D2D2D"
                            />
                          </svg>
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="drop-down-menu">

                          <Dropdown.Item
                            //key={index}
                            className="dropdown-menu-item"
                            onClick={() => {
                              // setSelectedCity(skill);
                              // setActiveTab("currentMonth");
                            }}
                          >
                            Role 1
                          </Dropdown.Item>

                        </Dropdown.Menu>
                      </Dropdown>}
                      <OfficeSelectComp
                        selectedOfficeList={selectedOfficeList}
                        setSelectedOfficeList={setSelectedOfficeList}
                        getLeaderBoardData={getLeaderBoardData}
                      />
                    </div>
                  </div>

                </div>

              </div>

            </div>

            <div className="tab-leader-content">
              {leaderBoardData.length > 0 ? (
                <div className="row">
                  {(parentTabKey === "teams" || !authBroker.payload?.user.role.includes("program_manager")) && leaderBoardData.map((item, index) => {
                    return (
                      index < 3 && (
                        <div className="col-md-12 mb-4 mnbg">
                          <div
                            className="course_management"
                            style={{ cursor: "default" }}
                          >
                            <div className="d-flex gap-5 w-100 leaderbox align-items-start">
                              <div className="img-box-leader">
                                <img
                                  src={
                                    _.isEmpty(item?.profile)
                                      ? "/images/avatar.svg"
                                      : item?.profile
                                  }
                                  alt="user"
                                />
                              </div>
                              <div className="foldertex">
                                <h2 className="mb-3 leadername">{item?.name}</h2>
                                {false && (
                                  <span className="d-flex align-items-center gap-2">
                                    <svg
                                      width="17"
                                      height="19"
                                      viewBox="0 0 17 19"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <g clip-path="url(#clip0_1907_109039)">
                                        <path
                                          d="M2.96924 15.8691C2.69678 16.001 2.37012 15.8867 2.23975 15.6143C2.10791 15.3418 2.22217 15.0151 2.49463 14.8848C3.15381 14.5669 3.81006 14.3047 4.46191 14.0981C5.11816 13.8901 5.77881 13.7378 6.44385 13.6411C6.78223 13.5913 7.1206 13.5576 7.45898 13.5371V12.9951L5.84912 11.7969C5.79053 11.7192 5.74805 11.6313 5.72314 11.5391H3.17578V11.5361C2.62793 11.5361 2.13281 11.3149 1.77539 10.9575C1.41797 10.6001 1.19678 10.105 1.19678 9.55713H1.19385V7.16064H0.681152V7.15771C0.493652 7.15771 0.322266 7.08154 0.200684 6.9585C0.0791016 6.83691 0.00439453 6.66846 0.00292969 6.48242L0 6.48096H0.00146484V5.92139C0.00146484 5.73242 0.0776367 5.5625 0.200684 5.44092C0.322266 5.31934 0.490723 5.24463 0.676758 5.24316L0.678223 5.2417H3.12305V5.24316C3.31201 5.24316 3.48193 5.31934 3.60352 5.44092V5.44238C3.7251 5.56397 3.7998 5.73242 3.80127 5.91846L3.80273 5.92139H3.80127V6.48096C3.80127 6.66992 3.7251 6.84131 3.60352 6.96143C3.48193 7.08301 3.31348 7.15771 3.12744 7.15771L3.12451 7.16064H2.47119V9.55566H2.46826C2.46826 9.74609 2.54883 9.92188 2.67773 10.0522C2.80664 10.1812 2.98242 10.2617 3.17432 10.2617V10.2588H3.59326V9.10303C3.59326 8.6123 4.02539 8.21094 4.55127 8.21094H11.5869C12.1143 8.21094 12.5449 8.6123 12.5449 9.10303V10.2588H12.9639V10.2617C13.1543 10.2617 13.3315 10.1812 13.4604 10.0522C13.5894 9.92334 13.6699 9.74609 13.6699 9.55566H13.667V7.16064H13.248V7.15771C13.0605 7.15771 12.8906 7.08154 12.7676 6.9585C12.646 6.83691 12.5713 6.66846 12.5698 6.48242L12.5684 6.47949H12.5698V5.91992C12.5698 5.73096 12.6475 5.56104 12.769 5.43945C12.8906 5.31787 13.0591 5.24316 13.2451 5.2417L13.248 5.24023H15.6929V5.2417C15.8818 5.2417 16.0518 5.31787 16.1733 5.43945V5.44092C16.2949 5.5625 16.3696 5.73096 16.3711 5.91699L16.3726 5.91992H16.3711V6.47949C16.3711 6.66699 16.2949 6.83838 16.1719 6.95996C16.0503 7.08154 15.8818 7.15625 15.6958 7.15625L15.6943 7.15918H14.9473V9.5542H14.9443C14.9443 10.1021 14.7231 10.5972 14.3657 10.9546C14.0083 11.312 13.5132 11.5332 12.9653 11.5332V11.5361H10.4824C10.4575 11.6489 10.4077 11.7559 10.3359 11.8481L8.73633 12.9395V13.5327C9.17871 13.5562 9.61963 13.606 10.062 13.6821C11.2661 13.8887 12.4658 14.2871 13.6641 14.8833C13.9351 15.0181 14.0449 15.3462 13.9102 15.6172C13.7754 15.8882 13.4473 15.998 13.1763 15.8633C12.0747 15.314 10.9746 14.9478 9.87891 14.7603C9.49805 14.6958 9.11719 14.6519 8.73779 14.6284V15.6787C8.73779 16.0317 8.45215 16.3174 8.09912 16.3174C7.74609 16.3174 7.46045 16.0317 7.46045 15.6787V14.6313C7.17334 14.6489 6.88623 14.6797 6.59912 14.7207C6.00146 14.8071 5.39795 14.9478 4.79297 15.1396C4.18066 15.3359 3.57275 15.5776 2.96924 15.8691ZM4.07812 0.5H12.0615C12.3267 0.5 12.5654 0.718262 12.542 0.980469L11.8828 7.18701C11.855 7.44922 11.666 7.66748 11.4023 7.66748H4.76953C4.50586 7.66748 4.3125 7.45068 4.28906 7.18701L3.59766 0.980469C3.57422 0.718262 3.81445 0.5 4.07812 0.5ZM13.4707 16.6279C13.9878 16.6279 14.4067 17.0469 14.4067 17.564C14.4067 18.0811 13.9878 18.5 13.4707 18.5C12.9536 18.5 12.5347 18.0811 12.5347 17.564C12.5347 17.0469 12.9536 16.6279 13.4707 16.6279ZM8.12695 16.6279C8.64404 16.6279 9.06299 17.0469 9.06299 17.564C9.06299 18.0811 8.64404 18.5 8.12695 18.5C7.60986 18.5 7.19092 18.0811 7.19092 17.564C7.19092 17.0469 7.60986 16.6279 8.12695 16.6279ZM2.7832 16.6279C3.30029 16.6279 3.71924 17.0469 3.71924 17.564C3.71924 18.0811 3.30029 18.5 2.7832 18.5C2.26611 18.5 1.84717 18.0811 1.84717 17.564C1.84717 17.0469 2.26611 16.6279 2.7832 16.6279Z"
                                          fill="#4F4C55"
                                        />
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_1907_109039">
                                          <rect
                                            width="16.374"
                                            height="18"
                                            fill="white"
                                            transform="translate(0 0.5)"
                                          />
                                        </clipPath>
                                      </defs>
                                    </svg>

                                    {item?.role ? item?.role : "-"}
                                  </span>
                                )}
                                <div className="separ">
                                  <span className="sepr">Score <strong>{item?.score}</strong></span>
                                  <span className="sepr">Office <strong>{item?.office}</strong></span>
                                  <span className="sepr">Rank <strong>{item?.rank}</strong></span>
                                  <span className="sepr">Country <strong>Type here</strong></span>
                                </div>
                              </div>
                            </div>

                          </div>
                        </div>
                      )
                    );
                  })}
                </div>
              ) : (
                <div className="col-md-12 notf-ound">
                  <div className="not-found mt-3">
                    <div className="interboxes">
                      <img src="/images/finwell-img/NoSearchResults.svg" alt="Not Found" />
                      <p>{t("No leaderboard data yet.")}</p>
                    </div>
                  </div>
                </div>
              )}
              <div className="row">
                <div className="col-md-12">
                  <div className="responsive-carousel-points-table">
                    <div className="course-info-table">
                      {((parentTabKey === "agents" && authBroker.payload?.user.role.includes("program_manager")) || leaderBoardData.length > 3) && (
                        <table className="table mb-0 office_list table-striped video-list">
                          <thead className="position-relative">
                            <tr>
                              {(parentTabKey === "agents" && authBroker.payload?.user.role.includes("program_manager")) && <th>
                                <div
                                  className={`form-check position-relative`}
                                  onClick={() => {
                                    let itemTemp = _.cloneDeep(leaderBoardData);
                                    itemTemp.forEach((item) => {
                                      if (isAllChecked) {
                                        item.isChecked = false;
                                      } else {
                                        item.isChecked = true;
                                      }
                                    })
                                    setIsAllChecked(!isAllChecked);
                                    setLeaderBoardData(itemTemp)
                                  }}
                                >
                                  <input
                                    className="form-check-input cursor-pointer"
                                    type="checkbox"
                                    checked={isAllChecked}
                                  />

                                </div>
                              </th>}
                              <th
                                className={`text-rank cursor-pointer sortingtable ${rankSort}`}
                                scope="col"
                                style={{ Width: "100px" }}
                                onClick={() => {
                                  setRankSort(
                                    rankSort === "asc" ? "desc" : "asc"
                                  );
                                }}
                              >
                                {t("Ranking")}
                              </th>
                              <th
                                className="text-naem"
                                scope="col"
                                style={{ minWidth: "300px" }}
                              >
                                {t("Name")}
                              </th>
                              {false && (
                                <th
                                  className="text-role"
                                  scope="col"
                                  style={{ minWidth: "200px" }}
                                >
                                  {t("Role")}
                                </th>
                              )}
                              <th
                                className="text-left "
                                scope="col"
                                style={{ minWidth: "200px" }}
                              >
                                {t("Office")}
                              </th>
                              <th
                                className="text-left "
                                scope="col"
                                style={{ minWidth: "200px" }}
                              >
                                {t("learningPoints")}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {leaderBoardData.length > 0 ? (
                              leaderBoardData.map((item, index) => {
                                return (parentTabKey === "teams" || !authBroker.payload?.user.role.includes("program_manager")) && index < 3 ? (
                                  ""
                                ) : (
                                  <tr
                                    key={`lp-${1}`}
                                    className={item.is_me && "my-position"}
                                  >

                                    {(parentTabKey === "agents" && authBroker.payload?.user.role.includes("program_manager")) && <td>
                                      <div
                                        className={`form-check position-relative ${(item.status === "completed" || item.profile_status === "completed") ? "opacity-half" : 'cursor-pointer'}`}
                                        onClick={() => {
                                          let itemTemp = _.cloneDeep(leaderBoardData);
                                          if (item.isChecked) {
                                            itemTemp[index].isChecked = false;
                                          } else {
                                            itemTemp[index].isChecked = true;
                                          }
                                          setLeaderBoardData(itemTemp)
                                        }}
                                      >
                                        <input
                                          className="form-check-input cursor-pointer"
                                          type="checkbox"
                                          checked={item.isChecked}
                                        />

                                      </div>
                                    </td>
                                    }
                                    <td>{item?.rank}</td>
                                    <td className="text-name">
                                      <div className="d-flex gap-2 names-hw align-items-start">
                                        <img
                                          src={
                                            _.isEmpty(item?.profile)
                                              ? "/images/avatar.svg"
                                              : item?.profile
                                          }
                                          width={24}
                                          height={24}
                                        />
                                        <div className="name-sse">
                                          {item?.name}
                                        </div>
                                      </div>
                                    </td>
                                    {false && (
                                      <td className="text-date">
                                        {item?.role ? item?.role : "-"}
                                      </td>
                                    )}
                                    <td className="text-left">{item?.office}</td>
                                    <td className="text-left">{item?.score}</td>
                                  </tr>
                                );
                              })
                            ) : (
                              <tr className="not-found">
                                <td colSpan={5}>
                                  <img
                                    src="/images/finwell-img/NoSearchResults.svg"
                                    alt="Not Found"
                                  />
                                  <p>No leaderboard data yet.</p>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {(parentTabKey === "agents" && authBroker.payload?.user.role.includes("program_manager")) && <>
              <div className="lw-filters filters-leaderboard-cd">
                <div className="inner-content-caoch pt-4">
                  <div className="s-earch-and-filters d-flex gap-4 justify-content-between mb-5">
                    <div className="search-filter position-relative">

                      <div className="anonymous-mode">
                        <strong>Publish Mode</strong>
                        <div className="allow-notif d-flex align-items-center gap-2">

                          Do you want to publish it?:
                          <label className="notifcation-switch" key={1}>
                            <input type="checkbox"
                              checked={isCheckedPublish}
                              name={""}
                              onChange={(e) => {
                                if (isCheckedPublish) {
                                  setIsCheckedPublish(false)
                                }
                                else {
                                  setIsCheckedPublish(true)
                                }
                              }}
                            />
                            <span className="backslid">
                              <span className="slider round"></span>
                              <span className="label on">Yes</span>
                              <span className="label off">No</span>
                            </span>

                          </label>
                        </div>
                      </div>

                      <div className="anonymous-mode mt-3">
                        <strong>Anonymous Mode</strong>
                        <div className="allow-notif d-flex align-items-center gap-2">

                          Do you want to publish it Anonymously?:
                          <label className="notifcation-switch" key={1}>
                            <input type="checkbox"
                              checked={isCheckedAnmos}
                              name={""}
                              onChange={(e) => {
                                if (isCheckedAnmos) {
                                  setIsCheckedAnmos(false)
                                }
                                else {
                                  setIsCheckedAnmos(true)
                                }
                              }}
                            />
                            <span className="backslid">
                              <span className="slider round"></span>
                              <span className="label on">Yes</span>
                              <span className="label off">No</span>
                            </span>

                          </label>
                        </div>
                      </div>
                    </div>

                    <div className="filter-section">
                      <div className="filter-option-listing d-flex justify-content-end gap-3">

                      </div>
                    </div>

                  </div>

                </div>

              </div>

              <div className="col-md-12">
                <div className="d-flex justify-content-end gap-4 btn-footer">
                  {false && <button
                    className="cancelbtn"
                  // onClick={() => setShowAdd(false)}   
                  >
                    Preview as Agent
                  </button>}
                  <button
                    className="btn-primary"
                  // onClick={() => setShowAdd(false)}   
                  >
                    Cancel
                  </button>
                  <button type="submit" className="btn-primary active-page" onClick={() => {
                    saveLeaderboardReq();
                  }}>Save</button>
                </div>
              </div>
            </>}
          </div>
        </div>
      </div>
    </>
  );
};
export default LeaderBoardComp;
